import React from 'react';

/**
 * Logo Orvian según tema: renderiza las dos variantes y Tailwind muestra la
 * correcta con la clase `dark` de <html> (dark:hidden / dark:block).
 * showText=true → wordmark completo "orvian"; false → solo la marca (hexágonos).
 * Conserva data-testid="gmail-logo" (lo usa el E2E).
 */
export function BrandLogo({ showText = true, className = '', variant }) {
  const light = showText ? '/brand/wordmark-light.png' : '/brand/mark-light.png';
  const dark = showText ? '/brand/wordmark-dark.png' : '/brand/mark-dark.png';
  const h = showText ? 'h-7' : 'h-8';
  // variant fija una versión (p.ej. el Login siempre es claro, ignore el tema)
  if (variant === 'light' || variant === 'dark') {
    return (
      <div className={`gmail-logo ${className}`} data-testid="gmail-logo">
        <img src={variant === 'light' ? light : dark} alt="Orvian" className={`${h} w-auto`} />
      </div>
    );
  }
  return (
    <div className={`gmail-logo ${className}`} data-testid="gmail-logo">
      <img src={light} alt="Orvian" className={`${h} w-auto dark:hidden`} />
      <img src={dark} alt="Orvian" className={`${h} w-auto hidden dark:block`} />
    </div>
  );
}

export default BrandLogo;
